var map = {
	"./Approve.svg": 68429,
	"./Balance.svg": 88502,
	"./BrowsingUsers.svg": 66453,
	"./Building.svg": 7153,
	"./Burger.svg": 80368,
	"./Ellipse.svg": 74703,
	"./Exclamation-Mark.svg": 38964,
	"./Gatherings.svg": 71344,
	"./Goals.svg": 24326,
	"./Home.svg": 52723,
	"./Houses.svg": 82532,
	"./Indicator.svg": 62131,
	"./Logo.svg": 10953,
	"./Logo_cp.svg": 68147,
	"./Payments.svg": 28229,
	"./Petition.svg": 49462,
	"./Petiton.svg": 66355,
	"./Purse.svg": 18224,
	"./Radio_State.svg": 57176,
	"./Radio_State_Disabled-Blue.svg": 40666,
	"./Radio_State_Disabled.svg": 61249,
	"./Repair-tool.svg": 4798,
	"./Survey.svg": 29336,
	"./Target.svg": 41945,
	"./Ticket.svg": 80927,
	"./UserPayments.svg": 17157,
	"./Vector.svg": 78994,
	"./add.svg": 70281,
	"./analytics.svg": 77022,
	"./apartment.svg": 70965,
	"./arrow-down_icon.svg": 26939,
	"./arrowDown.svg": 75144,
	"./arrowUp.svg": 75317,
	"./blank.svg": 31421,
	"./button_ozon.svg": 39188,
	"./check.svg": 50535,
	"./checked-green.svg": 20057,
	"./close.svg": 37674,
	"./config.svg": 45713,
	"./cp_logo.svg": 54326,
	"./defaulthome_icon.svg": 7531,
	"./delete.svg": 31673,
	"./document.svg": 71660,
	"./downarrow.svg": 19869,
	"./download.svg": 23694,
	"./edit-icon.svg": 44131,
	"./edit.svg": 76937,
	"./edit_icon.svg": 28635,
	"./enter.svg": 48999,
	"./error.svg": 68067,
	"./facebook.svg": 3536,
	"./group.svg": 59740,
	"./icon-edit.svg": 14614,
	"./image6.svg": 53177,
	"./importAction.svg": 363,
	"./info-icon.svg": 73359,
	"./keyboard_arrow_down-black-18dp.svg": 85260,
	"./logo_black_new_people.svg": 13278,
	"./logout-icon-dark.svg": 91136,
	"./logout-icon.svg": 10709,
	"./main-page-city.svg": 25950,
	"./main_mage_vote.svg": 56498,
	"./manual-voting.svg": 99159,
	"./mark.svg": 54661,
	"./mohu.svg": 95037,
	"./office.svg": 3189,
	"./parkinglot.svg": 58782,
	"./passport.svg": 42842,
	"./pencil.svg": 57937,
	"./read.svg": 88085,
	"./span.svg": 77087,
	"./spyware.svg": 20582,
	"./supporterImg.svg": 46927,
	"./telegram.svg": 40351,
	"./unread.svg": 36559,
	"./upperarrow.svg": 88526,
	"./user-icon.svg": 83257,
	"./user.svg": 13816,
	"./users-solid.svg": 36176,
	"./users.svg": 13884,
	"./vertical-ellipsis.svg": 61390
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 29866;